import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { channelsPlaylistsEdit_template } from "../components/templates/channelsPlaylistsEdit_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class channels_playlists_edit extends vnModule_knockoutJS {
    protected channelsPlaylistsEdit: channelsPlaylistsEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected ApiUrls: any = {
        channelsSuggestionsGet: `/api/brand/${this.getVnAppZone().app.params.idBrand}/channels/search/`,
    };

    protected getModuleName(): string {
        return "channels_playlists_edit";
    }

    buildContent(): Array<Element> {
        this.channelsPlaylistsEdit = new channelsPlaylistsEdit_template(
            "channels_playlists_edit",
            this.viewModel,
            this,
        );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Edit Playlist");

        return [this.channelsPlaylistsEdit.build()];
    }

    public fillPage(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.channelsPlaylistsEdit.setBrand(idBrand);
        }
        this.getPlaylist();
    }

    protected getPlaylist() {
        let idPlaylist = this.getVnAppZone().getApp().params.idPlaylist;

        if (idPlaylist) {
            this.loadingIn(this.channelsPlaylistsEdit.builtTemplate);
            let usrReq_url: string = `/api/brand/${this.getVnAppZone().getApp().params.idBrand}/channels/playlists/get/${idPlaylist}`;

            let usrReq_params: Array<Array<string>> = [];
            let vm = this.channelsPlaylistsEdit.getViewModelForRequest();
            vm['lockItem'] = true;
            usrReq_params.push(["data", ko.toJSON(vm)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdl.onReadyStateFunction = this.onGetPlaylistReturn;
            this.XHRHdl.execute();
        }
    }

    protected onGetPlaylistReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let playlist = responseParsed.data[0];
                playlist.articles.forEach((article) => {
                    if(article.dateMostRecentPublishedStatus && article.dateMostRecentPublishedStatus.date) {
                        article.dateMostRecentPublishedStatus = article.dateMostRecentPublishedStatus.date;
                    }
                });

                obj.channelsPlaylistsEdit.setPlaylist(responseParsed.data[0]);
            });
            obj.loadingOut(obj.channelsPlaylistsEdit.builtTemplate);
        };
    }

    protected edit(id) {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect(`/brand/${idBrand}/categorization/playlists/edit/${id}`);
    }
    protected cancel(id) {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        this.releaseLock(idBrand, id, `/brand/${idBrand}/categorization/playlists/`);
    }


    protected releaseLock(idBrand, idPlaylist, redirectUrl) {
        if(idPlaylist) {
            this.cancelRequest("releaseLock");
            let subViewModel = {};
            let usrReq_url: string = `/api/brand/${idBrand}/channels/playlists/release/${idPlaylist}/`;
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

            if(redirectUrl) {
                this.XHRHdl.onReadyStateFunction = function() {
                    if(redirectUrl) {
                        page.redirect(redirectUrl);
                    }
                };
            }

            this.XHRHdl.execute();
        } else {
            if(redirectUrl) {
                page.redirect(redirectUrl);
            }
        }
    }

    public getSavePostData() {
        return {
            id: this.channelsPlaylistsEdit.getTemplateViewModel().id(),
            description: this.channelsPlaylistsEdit.getTemplateViewModel().description(),
            isAvailableForUse: this.channelsPlaylistsEdit.getTemplateViewModel().isAvailableForUse(),
            image: this.channelsPlaylistsEdit.imageWidgetForVideoThumbnail.getImage()
                ? this.channelsPlaylistsEdit.getTemplateViewModel().image()
                : null,
            title: this.channelsPlaylistsEdit.getTemplateViewModel().title(),
            idChannel: this.channelsPlaylistsEdit.channelFilter.getIdTag(),
            articles: this.channelsPlaylistsEdit.getArticles().map((article) => [article.id, article.position]),
        };
    }

    protected save() {
        this.loadingIn(this.channelsPlaylistsEdit.builtTemplate);

        let image = this.channelsPlaylistsEdit.imageWidgetForVideoThumbnail.getImage();
        if (image) {
            this.channelsPlaylistsEdit.imageWidgetForVideoThumbnail.setImage(image);
            this.channelsPlaylistsEdit.setImage(image);
        }

        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/channels/playlists/save";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.getSavePostData())]);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSave;
        XHRHdl.execute();
    }

    protected onSave(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                //console.log(JSON.parse(req.request.response));
                //return;
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Playlist saved successfully!",
                );
                page.redirect("/brand/" + obj.getVnAppZone().app.params.idBrand + "/categorization/playlists/");
            });
            obj.loadingOut(obj.channelsPlaylistsEdit.builtTemplate);
        };
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls !== undefined && this.XHRHdls[requestName] !== undefined) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected getTagsSuggestion(keyword, idElement) {
        this.cancelRequest("getChannelsSuggestion");
        let usrReq_url: string = `${this.ApiUrls.channelsSuggestionsGet}`;
        let subViewModel = { filter: { keyword: keyword }, idElement: idElement };
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getChannelsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getChannelsSuggestion"].onReadyStateFunction = this.onGetChannelsSuggestionReturn;
        this.XHRHdls["getChannelsSuggestion"].execute();
    }

    protected onGetChannelsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data) {
                    obj.channelsPlaylistsEdit.setChannelFilter(responseParsed.data);
                }
            });
        };
    }

    protected filterSimpleOnChange(idElement) {
        switch(idElement) {
            case "channelFilter":
                this.channelsPlaylistsEdit.handleChannelChange();
                break;
            case "articleFilter":
                this.channelsPlaylistsEdit.addArticle(this.channelsPlaylistsEdit.articleFilter.getArticleObj());
                this.channelsPlaylistsEdit.articleFilter.clearInput();
                break;
        }
    }

    protected getArticlesSuggestion(keyword, idElement) {
        this.cancelRequest("getArticlesSuggestion");

        let subViewModel = { list: { keyword: keyword }, idElement: idElement, templateName: "Video", idChannel: this.channelsPlaylistsEdit.getIDChannel() };

        let usrReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/search/article/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestions;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    protected onGetArticlesSuggestions(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if(req.request.response){
                    let responseParsed = JSON.parse(req.request.response);
                    if (responseParsed.data.articles) {
                        if (responseParsed.data.idElement == "articleFilter") {
                            obj.channelsPlaylistsEdit.articleFilter.setOptions(responseParsed.data.articles);
                        }
                    }
                }
            });
        };
    }

    protected showArticle(article) {
        if(article && article.id){
            const idBrand = this.getVnAppZone().getApp().params.idBrand;
            window.open(`/brand/${idBrand}/articles/view/${article.id}`, '_blank');
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/channels_playlists_edit.ts